import styled from 'styled-components';

const StyledSideNav = styled.nav`
  width: 100%;
  display: grid;
  grid-template-columns: 30% 70%;
  grid-template-rows: 100%;
  overflow: auto;
`;

export default StyledSideNav;
